import { PanelType } from '@fluentui/react';
import { Panel } from '@h2oai/ui-kit';

import { AddEditModelForm } from '../../../components/AdminSettings/components/AddEditModelForm/AddEditModelForm';
import { stylesPanel } from '../../../components/AIEnginesPage/components/AIEMPanel/AIEMPanel';
import { NotebookEntitiesMap } from '../../../notebook/entity/services';
import { NotebookKernelEntityType } from '../../../notebook/entity/types';
import { KernelSettingsEditPanelProps, NotebookEntityModel } from './types';

export const KernelSettingsEditPanel = (props: KernelSettingsEditPanelProps) => {
  const { panelTitle, onDismiss, isCreate, onSave, entity, model } = props;

  if (!model) return <></>;

  return (
    <Panel
      isLightDismiss
      customWidth="500px"
      headerText={panelTitle}
      isFooterAtBottom
      isOpen={true}
      onDismiss={onDismiss}
      type={PanelType.custom}
      styles={stylesPanel}
    >
      <AddEditModelForm<NotebookEntityModel, NotebookKernelEntityType>
        requestParams={{ parent: 'workspaces/global' }}
        requestPath={props.requestPath}
        entitiesMap={NotebookEntitiesMap}
        entity={entity}
        model={model}
        isCreate={isCreate}
        onSave={onSave}
        onDismiss={onDismiss}
      />
    </Panel>
  );
};
